/**
 * Medplum FHIR `_count` for large list searches (server page max 1000).
 * Use for observation batches, encounter lists, practitioner pickers, etc., instead of repeating `1000`.
 */
export const MEDPLUM_SEARCH_PAGE_MAX_COUNT = 1000;

/**
 * Same cap as {@link MEDPLUM_SEARCH_PAGE_MAX_COUNT}; kept for call sites that are explicitly observation reads.
 */
export const MEDPLUM_OBSERVATION_SEARCH_MAX_COUNT = MEDPLUM_SEARCH_PAGE_MAX_COUNT;
